import node from './node.svg';
import ts from './ts.svg';
import docker from './docker.svg';
import mongodb from './mongodb.svg';
import mysql from './mysql.svg';
import postgresql from './postgresql.svg';
import sequelize from './sequelize.svg';
import mocha from './mocha.svg';

const backend = [node, ts, docker, mongodb, postgresql, mysql, sequelize, mocha];

export default backend;
